import React from "react";
import { useTranslation } from "react-i18next";
const CHEMICAL_LEVELS = [
  {
    id: "soap",
    name: "Soap",
    value: 36,
    color: "#F8BB18",
  },
  {
    id: "wax",
    name: "Wax",
    value: 72,
    color: "#63D376",
  },
  {
    id: "tireShine",
    name: "Tire Shine",
    value: 19,
    color: "#EB5A5A",
  },
  {
    id: "dryingAgent",
    name: "Drying Agent",
    value: 78,
    color: "#63D376",
  },
  {
    id: "water",
    name: "Water",
    value: 52,
    color: "#F8BB18",
  },
];

const ChemicalLevel = () => {
  const { t } = useTranslation();
  return (
    <div className="chemical_level">
      <div className="chemical_level__header">
        <h3 className="fs_20">{t("Chemical Level")}</h3>
        <span className="chemical_badge">{t("Operational")}</span>
      </div>

      <div className="chemical_level__list">
        {CHEMICAL_LEVELS.map((item) => (
          <div key={item.id} className="chemical_item">
            <div className="chemical_bar">
              <span className="chemical_percent">{item.value}%</span>
              <span
                className="chemical_bar__fill"
                style={{
                  height: `${item.value}%`,
                  backgroundColor: item.color,
                }}
              />
            </div>

            <p className="chemical_name">{item.name}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ChemicalLevel;
